import React from "react";
import Footer from "./Footer";
import ReviewApproval from "../features/ReviewApproval/component/ReviewApproval";

function ReviewApprovalPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <ReviewApproval />

      <Footer />
    </div>
  );
}

export default ReviewApprovalPage;
